if (document.querySelector('#js-tack-commanddirectory')) {
    import('./tackcommands').then(() => { })
}

if (document.querySelector('#js-glossary')) {
    import('./glossary').then(() => { })
}
